<template>
  <div class="cons">
    <div class="card my-3" style="min-height: 200px">
      <b-row>
        <b-col sm="12">
          <h4
            :class="{
              'title text-end mb-4': lang ==1,
              'title text-start mb-4': lang ==2,
            }"
            
          >
            {{ $t("consumption") }}
            <span v-if="mdm_utilites==3" :class="{
                      'text-end' : lang ==1,
                      'text-start': lang ==2,
                    }">{{ $t("m3") }}</span>
            <span v-if="mdm_utilites==1" :class="{
                      'text-end ' : lang ==1,
                      'text-start': lang ==2,
                    }" > {{unit}}</span>
          </h4>
        </b-col>
      
        <!-- <b-col cols="12" md="6" class="relative" style="min-height: 360px">
          <Loading v-if="chartLoading" />
          <ErrorHandler v-if="chartError"  :error="errorCode"/>

          <div class="h-100">
            <apexchart
              id="chart"
              class="h-100 d-flex align-items-center"
              v-if="showChart"
              type="area"
              height="350"
              :options="chartOptions"
              :series="series"
            ></apexchart></div
        ></b-col> -->

        <b-col md="12" class="relative">
          <div class="">
            <loading v-if="consumptionLoading" />
            <ErrorHandler v-if="consumptionError" :error="errorCode"/>

            <CustomeTable
              v-if="!consumptionError"
              :headers="headers"
              :items="consumption"
              :showPager="false"
              :perPage="4"
              :show="show"
              :lang="lang"
            />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Loading from "@/components/Loading.vue";
import CustomeTable from "@/components/CustomeTable.vue";
import ErrorHandler from "../ErrorHandler.vue";
import {getCookie} from "@/utils"

export default {
  components: {
    apexchart: VueApexCharts,
    Loading,
    ErrorHandler,
    CustomeTable,
  },
  props: {
    code: {
      default: () => " ",
    },
    selectedMeterObject:{
      default: () => "",
    },
    consumptionArray:{
      default: () => "",
    },
    lang:{
      default: () => "",
    },
    consumption_error_msg:{
      default: () => {}
    },
    cons_error:{
      default: () => {}
    },
  },
  data() {
    return {
      consumption: [],
      consumptionLoading: true,
      consumptionError: false,
      mdm_utilites:0,
      // chartLoading: true,
      // chartError: false,
      errorCode: 2,
      unit:"",
      unity:'',
      show:false,
      // showChart: false,
      // showEstimatedMoney:false,

      series: [
        {
          name: this.$t("energy_consumption_per_month"),
          data: [],
        },
      ],
      // chartOptions: {
      //   chart: {
      //     height: 450,
      //     zoom: {
      //       enabled: false,
      //     },
      //   },
       
      //   dataLabels: {
      //     enabled: false,
      //   },
      //   markers: {
      //     size: 5,
      //     discrete: [{ seriesIndex: 0, dataPointIndex: 6, fillColor: 'rgb(215, 66, 30);', strokeColor: '#fff', size: 7, }]
      //   },
      //    forecastDataPoints: {
      //     count:1
      //   },
      //   stroke: {
      //     curve: 'smooth',
      //   },
      //   xaxis: {
      //     type: "category",
      //   },
      //   yaxis: {
      //   labels: {
      //     formatter: function (value) {
      //       return new Intl.NumberFormat('en-IN').format(value);
      //     }
      //   }
      //   },
      //   tooltip: {
      //     custom: ({ series, seriesIndex, dataPointIndex, w }) => {
      //       const amount = new Intl.NumberFormat('en-IN').format(this.series[seriesIndex].data[dataPointIndex].money);
      //       const value = new Intl.NumberFormat('en-IN').format(this.series[seriesIndex].data[dataPointIndex].y);
      //       const date = this.series[seriesIndex].data[dataPointIndex].x;
      //       let esimatedflag=this.showEstimatedMoney;
   
      //       if(dataPointIndex!=6){
 
      //       return `
      //       <div class="custom_tooltip ${this.$i18n.locale == 'ar' ? 'rtl' : 'ltr'}" >
      //            <div class="custom-tooltip-date-container">
      //             <h6> ${date} </h6>
      //           </div>
      //           <div class="custom-tooltip-conent-container">
      //             <span class="rtl">
      //                     ${this.$t( "energy_consumption_per_month")} :
              
      //                     <b style="font-weight: bold !important">${value} ${this.unit}</b>
      //             </span>
      //             <br>
      //             <span>  ${this.$t("estimated_money")}: <b style="font-weight: bold !important">
      //                     ${amount} ${this.$t("egp")}</b>
      //              </span> 
      //              </div>
      //           </div>`;
      //       }

      //       else{
      //       return `<div class="custom_tooltip ${this.$i18n.locale == 'ar' ? 'rtl' : 'ltr'}" >
      //           <div class="custom-tooltip-date-container" style="background-color:rgb(215, 66, 30,0.5);">
      //             <h6> ${date} </h6>
      //             </div>
      //           <div class="custom-tooltip-conent-container">
      //             <span class="rtl">
      //                 ${this.$t( "estimated_consumption_for_next_month")} :
      //                 <b style="font-weight: bold !important">${value} ${this.unit} </b>
      //             </span>
      //             <br>
      //             <span v-if="esimatedflag==true">  ${this.$t("est_money")}: <b style="font-weight: bold !important">
      //                     ${amount} ${this.$t("egp")}</b>
      //              </span> 
      //           </div>`;
      //       }
      //     }
      //   },
      // },
      headers: [
        {
          locale: "mdm_billing_cycle",
          notation: true,
          notation_locale: "month_date_notation",
        },
        {
          locale: "energy_diff",
          notation: true,
          notation_locale: "kwh",
        },
        {
          locale: "est_tariff_value",
          notation: true,
          notation_locale: "egp",
        },
      ],
    };
  },
  watch: {
    selectedMeterObject() {
      if (this.selectedMeterObject && this.selectedMeterObject != "") {
        this.initialize();
      }
    },
    cons_error(){
          this.errorCode = this.consumption_error_msg;
          this.consumptionError = this.cons_error;
      if(this.cons_error==true){
          this.show=false;
          this.consumptionLoading = false;
          this.consumption = [];
      }
    },
   
    
  },
  methods: {
    async   getConsumptionArray(){
    return this.consumptionArray;
    },
   async getMeterData(){
      this.mdm_utilites=this.selectedMeterObject.mdm_utilities;
      return this.selectedMeterObject;
    },
    initialize() {
      this.consumptionLoading = true;
      // this.chartLoading = true;
          let estimated={
              money: "",
              x: "",
              y: ""
            }
         this.getMeterData()
        .then((data) => {
           estimated.money=data.est_money;
           if(estimated.money!==null ||estimated.money!=="Zero") { 
             this.showEstimatedMoney=true 
           }

           estimated.y= data.estimated_consumption;
           if(data.last_reading_date != 0 && data.last_reading_date != null) {
             estimated.x=data.last_reading_date.split(" ");
             estimated.x=estimated.x[0].split('/').slice(1).join('/');
           }
           
        }).then(()=>{
   
        this.getConsumptionArray()
        .then((data) => {
        this.series[0].data = data
            .map((item) => {
              return {
                x: item.mdm_billing_cycle,
                y: item.energy_diff,
                money: item.est_tariff_value,
              };
            })
            .reverse();
   
          this.series[0].data.push( estimated);
          this.consumption = this.formatNumber(data);

        /***************************************** */
          if (this.series[0].data.length > 7) {
            this.series[0].data = this.series[0].data.slice(
              this.series.data[0] - 13
            );
          }     
        })
        .then(() => {
          this.show=true;
          this.consumptionLoading = false;

        })
       
          
        })
///////////////////////////////////////////
    },

    formatNumber(data) {
      return data.map(month => {
        month.est_tariff_value= new Intl.NumberFormat('en-IN').format(month.est_tariff_value)
        month.energy_diff= new Intl.NumberFormat('en-IN').format(month.energy_diff)
        return month
      })
  },
     
  },mounted() {
    this.$root.$on('send-unity', unity => {
      this.unity=unity;
       this.headers[1].notation_locale=this.unity;
       this.unit=this.unity;
    });
}

};
</script>

<style >
.custom-tooltip-conent-container {
  padding: 10px;
}

.custom-tooltip-date-container {
    background-color: rgb(233, 233, 233);
    padding: 5px;
}

.title {
      color: #002369;
    font-size: 16px;
    font-weight: 700;
}

h4 span{
  font-size: 12px;
  font-weight: 500;
}

table,
td,
th {
  border: 1px solid #ddd !important;
  text-align: left;
}

table {
  border-collapse: collapse;
  width: 100%;
  color: black;
}

th,
td {
  padding: 15px;
}

tr:hover {
  background-color: lightgray;
}
.titleTable {
  font-weight: bold;
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .table-responsive {
    font-size: 10px;
  }
}

#chart {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.card{
  min-height: 200px;
    margin: 0px auto;
    max-width: 856px;
    border-radius: 8px !important;
}
/* .cons .relative{
  padding: 0px;
  border: 0px;
} */
</style>
